export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_41-a19918ec80522302a14f81fc16c1ca04.jpg";